import React from "react";
import { Tooltip } from "@react95/core";
import { Mail } from "@react95/icons";
import { useApp } from "../../context/AppContext";
import { useMail } from "../../context/MailContext";
import { MailClientDef } from "../Modal/MailClient";

export default function MailTrayIcon() {
  const { emails } = useMail();
  const { openModal } = useApp();

  const unreadCount = emails.filter((e) => !e.isRead).length;

  // only show in tray when there are unread messages
  if (unreadCount === 0) return null;

  return (
    <Tooltip text={`Mail: ${unreadCount} unread`}>
      <div
        onClick={() => openModal(MailClientDef)}
        style={{
          width: "20px",
          height: "20px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        title={`${unreadCount} unread message(s)`}
        aria-label={`mail (${unreadCount} unread)`}
      >
        <Mail variant="16x16_4" />
      </div>
    </Tooltip>
  );
}
